module.exports = __webpack_public_path__ + "static/img/promotion_member_icon.fbbb8e09.png";